(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function() {
    let accountIcon = document.querySelector('.header__icon--account');
    if (accountIcon) {
      accountIcon.style.removeProperty("left");
      accountIcon.style.removeProperty("top");
    }
    let searchIcon = document.querySelector('.header__icon--search span');
    if (searchIcon) {
      searchIcon.style.removeProperty("left");
      searchIcon.style.removeProperty("top");
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-buy-box"] && !Shopify.designMode) return;
  try {
    
  // ==========================================================================
  // Custom buy-box selector wiring (2026-06-18). Drives our own size + plan
  // control: on selection it sets the Dawn form's variant id (.product-variant-id),
  // the Skio selling_plan (.lp-selling-plan, '' for one-time), and rewrites the
  // in-button price (.product-form__submit--current-price) for size x plan. Scoped
  // per .lp-buybox instance (both slot-main + slot-closing run independently) and
  // idempotent + re-bound on shopify:section:load so the theme editor can't break it.
  // ==========================================================================
  (function () {
    function initBuyBox(root) {
      if (!root || root.dataset.lpWired === '1') return;
      root.dataset.lpWired = '1';

      var sizes = root.querySelectorAll('.lp-buybox__sizes .lp-buybox__size');
      var plans = root.querySelectorAll('.lp-buybox__plans .lp-buybox__plan');
      var spInput = root.querySelector('.lp-selling-plan');
      var idInput = root.querySelector('.product-variant-id');
      var atcPrice = root.querySelector('.product-form__submit--current-price');
      var subPrice = root.querySelector('.js-sub-price');
      var oncePrice = root.querySelector('.js-once-price');
      var perday = root.querySelector('.js-perday');

      function sel(list) {
        for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('is-sel')) return list[i]; }
        return list[0] || null;
      }
      function refresh() {
        var s = sel(sizes), p = sel(plans);
        if (!s || !p) return;
        var isSub = p.getAttribute('data-plan') === 'sub';
        if (idInput) idInput.value = s.getAttribute('data-variant');
        if (spInput) spInput.value = isSub ? p.getAttribute('data-selling-plan') : '';
        if (subPrice) subPrice.textContent = s.getAttribute('data-sub');
        if (oncePrice) oncePrice.textContent = s.getAttribute('data-once');
        if (perday) perday.textContent = s.getAttribute('data-perday');
        if (atcPrice) atcPrice.textContent = isSub ? s.getAttribute('data-sub') : s.getAttribute('data-once');
      }
      function choose(group, btn) {
        for (var i = 0; i < group.length; i++) {
          group[i].classList.remove('is-sel');
          group[i].setAttribute('aria-checked', 'false');
        }
        btn.classList.add('is-sel');
        btn.setAttribute('aria-checked', 'true');
        refresh();
      }
      sizes.forEach(function (b) { b.addEventListener('click', function () { choose(sizes, b); }); });
      plans.forEach(function (b) { b.addEventListener('click', function () { choose(plans, b); }); });
      refresh(); // sync defaults (first size + Subscribe) into the form + price on load
    }
    function initAll() {
      document.querySelectorAll('.lp-buybox').forEach(initBuyBox);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    // Theme editor: re-wire the reloaded section instance.
    document.addEventListener('shopify:section:load', function (e) {
      var scope = e.target && e.target.querySelectorAll ? e.target : document;
      scope.querySelectorAll('.lp-buybox').forEach(function (el) { el.dataset.lpWired = ''; initBuyBox(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
